import { motion } from "framer-motion";
import { ArtistCard } from "./ArtistCard";

export const LineupSection = ({ artists }) => {
  return (
    <section className="relative bg-tile py-24 sm:py-32 px-4 sm:px-6" data-testid="lineup-section">
      <div className="max-w-6xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-4"
        >
          The Lineup
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-tight mb-14"
        >
          Three Nights' Worth<br />of Sound in One
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {artists.map((artist, i) => (
            <ArtistCard artist={artist} index={i} key={artist.id} />
          ))}
        </div>
      </div>
    </section>
  );
};
